import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: 'Transaction identifier',
    hidden: true,
    sortable: true,
  },

  {
    name: 'transferDate',
    label: 'Date created',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: true,
  },
  {
    name: 'sum',
    label: 'Amount',
    filterModalPlacement: 'right',
  },
  {
    name: 'debitAccountId',
    label: 'Debit account No.',
    sortable: true,
  },
  {
    name: 'debitAccount',
    label: 'Debit account description',
  },
  {
    name: 'creditAccountId',
    label: 'Credit account No.',
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'creditAccount',
    label: 'Credit account description',
  },
  {
    name: 'documentNumber',
    label: 'Doc. N',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'info',
    label: 'Info',
    filterModalPlacement: 'right',
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
  {
    name: 'accountId',
    hidden: true,
  },
];

export const columnsLabels = {
  transferDate: 'Date created',
  transferDateFrom: 'Date created From',
  transferDateTo: 'Date created To',
  currencyId: 'Currency',
  debitAccountId: 'Debit account No.',
  creditAccountId: 'Credit account No.',
  id: 'Transaction identifier',
  documentNumber: 'Doc. N',
  info: 'Info',
  accountId: 'Account',
};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  documentNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  info: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  debitAccountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  creditAccountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  accountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  id: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'accountId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'transferDate',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'debitAccountId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Search by number or name',
  },
  {
    name: 'creditAccountId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Search by number or name',
  },
  {
    name: 'id',
    type: FilterType.TEXT,
    placeholder: 'Enter identifier...',
  },
  {
    name: 'documentNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter document number...',
  },
  {
    name: 'info',
    type: FilterType.TEXT,
    placeholder: 'Enter info...',
  },
];
